import { getEmptyLayout } from '@/layout';
import { getDefaultStaticProps } from '@/utils/next';
import { PrivacyPolicyPage } from '@/views/PrivacyPolicyPage';
export default function Policy() {
  return <PrivacyPolicyPage data-sentry-element="PrivacyPolicyPage" data-sentry-component="Policy" data-sentry-source-file="index.page.tsx" />;
}
export const getStaticProps = getDefaultStaticProps;
Policy.getLayout = getEmptyLayout;